export const colors = {
  ctaLight: "#F4F4F8",
  ctaMain: "#3d00ba",
  ctaSecondaryOne: "#4A00DD",
  ctaInactive: "#E7ECF0",
  textPrimary: "#0D2531",
  textSecondary: "#8B8FA1",
  errorLight: "#FEF4F5",
  errorMedium: "#DC142D",
  errorDark: "#B21024",
  successLight: "#EFFFEF",
  successMedium: "#008600",
  successDark: "#006800",
  white: "#FFFFFF",
  black: "#000000",
  blackHover: "#111111",
  transparent: "transparent",
  greyBorder: "#e2e2e2",
  warningOrange: "#DD8014",
  whiteHover: "#F3F3F3",
  actionButtonHover: "#704DFF",
  buttonPrimaryWhite:
    "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.04) 100%), #FFFFFF",
  buttonAction:
    "linear-gradient(0deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.00) 100%), #704DFF",
  actionBorder: "#5E3CEA",
  buttonDelete:
    "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(0, 0, 0, 0.10) 100%), #DC142D",
  blueLight: "#E1E5FD",
  blueMedium: "#C8D0FB",
  blueDark: "#1642A2",
  blueInteractive: "#2879EF",
  orangeLight: "#FEE0D3",
  orangeMedium: "#FEC6AC",
  organgeDark: "#7C4101",
};
